import React, { Component } from 'react'

import style from './Grid.css'

export default class Col extends Component {
  render() {
    const className = style[`Col${this.props.size || 12}`]

    return (
      <div
        {...this.props}
        
        className={`${className} ${(this.props.float) ? style['float'+this.props.float] : ''} ${this.props.className || ''}`}
        style={{
          ...this.props.style
        }}
        >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/Grid/Col.js